import { Observable } from 'rxjs';
import { Plan } from '@domain/aggregates';

export abstract class PlansDataSource {
  abstract listPlans(): Observable<Plan[]>;
}
